import { useEffect, useRef } from 'react';

export default function usePrevious<Value>(value: Value): Value | undefined {
  const ref = useRef<Value>(undefined);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
